<template>
    <div>
        <div class="izvod-wrapper">
            <div class="izvod-title">Izvod iz sudskog registra</div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Tvrtka</div>
                <div v-for="(tvrtka,key) in izvod.skracene_tvrtke" :key="key" class="izvod-entry-content">{{tvrtka.ime}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Nadležni sud</div>
                <div class="izvod-entry-content">{{izvod.sud_nadlezan.naziv}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">MBS</div>
                <div class="izvod-entry-content">{{izvod.potpuni_mbs}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">OIB</div>
                <div class="izvod-entry-content">{{izvod.potpuni_oib}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Status</div>
                <div v-for="(postupak,key) in izvod.postupci" :key="key" class="izvod-entry-content">{{postupak.vrsta.znacenje}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Sjedište/adresa</div>
                <div v-for="(sjediste,key) in izvod.sjedista" :key="key" class="izvod-entry-content">
                    {{`${sjediste.naziv_naselja} (Grad/Općina ${sjediste.naziv_opcine})`}}<br>
                    {{`${sjediste.ulica} ${sjediste.kucni_broj}`}}
                </div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Adresa elektroničke pošte</div>
                <div v-for="(adresa,key) in izvod.email_adrese" :key="key" class="izvod-entry-content">{{adresa.adresa}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Temeljni kapital</div>
                <div v-for="(tem_kap,key) in izvod.temeljni_kapitali" :key="key" class="izvod-entry-content">{{tem_kap.iznos.toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")}} {{tem_kap.valuta.naziv}} {{tem_kap.valuta.naziv == 'kuna' ? ` / ${(tem_kap.iznos/7.5345).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")} euro (fiksni tečaj konverzije 7,5345)` : ''}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Pravni oblik</div>
                <div v-for="(prav_oblik,key) in izvod.pravni_oblici" :key="key" class="izvod-entry-content">{{prav_oblik.vrsta_pravnog_oblika.naziv}}</div>
            </div>
            <div class="izvod-entry">
                <div class="izvod-entry-title">Predmet poslovanja</div>
                <div v-for="(predmet_posl,key) in izvod.predmeti_poslovanja" :key="key" class="izvod-entry-content">
                    <div v-if="predmet_posl.djelatnost_tekst != undefined" class="multi-row-element"><div class="rbr">*</div><div class="djelatnost">{{predmet_posl.djelatnost_tekst}}</div></div>
                    <div v-if="predmet_posl.nac_klas_djelatnosti != undefined" class="multi-row-element"><div class="rbr">{{predmet_posl.nac_klas_djelatnosti.sifra}}</div><div class="djelatnost">{{predmet_posl.nac_klas_djelatnosti.puni_naziv}}</div></div>
                </div>
            </div>
            <div class="footnote">Izvod je automatski generiran uz pomoć <a href="https://sudreg-podaci.pravosudje.hr/docs/services">Portala otvorenih podataka Sudskog registra</a></div>
        </div>
    </div>
</template>

<script>

export default {
    components:{
    },
    data() {
        const izvod = this.$store.state.temp_json;
        return {
            izvod: izvod,
        }
    },
    methods: {
        getEuri(pare){
            return ` / ${(pare/7.5345).toFixed(2).toString().replaceAll('.', ',').replace(/(\d)(?=(\d{3})+(?:\,\d+)?$)/g,"$1.")} euro (fiksni tečaj konverzije 7,5345)`
        }
    },
    mounted() {
        document.body.classList.add("new-entry");

    },
    destroyed() {
        document.body.classList.remove("new-entry");
    },
}
</script>